export function normalizeNumericIdentifier(identifier: string): string | undefined {
  const value = identifier.trim();
  if (!/^\d+$/.test(value)) return undefined;

  return value.replace(/^0+(?=\d)/, "");
}

export function normalizePositiveSafeIntegerIdentifier(identifier: string): string | undefined {
  const normalizedIdentifier = normalizeNumericIdentifier(identifier);
  if (normalizedIdentifier === undefined) return undefined;

  const numericIdentifier = Number(normalizedIdentifier);
  return Number.isSafeInteger(numericIdentifier) && numericIdentifier > 0 ? normalizedIdentifier : undefined;
}
